import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LicenseListPayload, LicenseListResponse} from './license.models';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {NGXLogger} from 'ngx-logger';
import {environment} from '@hb/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicenseDataService {

  constructor(private http: HttpClient, private logger: NGXLogger) {
  }

  load(): Observable<LicenseListPayload> {
    return this.http.get<LicenseListResponse>(`${environment.api}/licenses`).pipe(
      map((res) => ({items: res.datalist}))
    );
  }
}
